/**
 * FAB Modal.
 *
 * @class FABModal
 * @static
 * @method handle_click
 * @method navigation_maximize
 * @method navigation_hotkey
 */
export default class FABModal {
  /**
   * Handle Click
   *
   * @param {Object} e - The event object.
   * @return void
   * */
  static handle_click(e) {
    // Grab variables.
    let { fab_item: fab } = e.detail;

    // If dialog exist on window, open it.
    if (window.FAB_PLUGIN?.dialogs?.[`fab-modal-${fab.ID}`]) {
      window.FAB_PLUGIN.dialogs[`fab-modal-${fab.ID}`].open();
    } else {
      FABModal.load_dialog(fab);
    }
  }

  /**
   * Load Dialog
   *
   * @param {Object} fab - The FAB object.
   * @return void
   * */
  static load_dialog(fab) {
    // Uncheck FAB.
    jQuery('#fab-checkbox').prop('checked', false);
    jQuery('#fab-checkbox').prop('checked', false);
    jQuery('#fab-checkbox').trigger('click');
    jQuery('#fab-checkbox').click();

    // Variables.
    let targetContent = `#fab-modal-${fab.ID}`;

    // Theme.
    let theme = [
      `fab-modal-${fab.ID}`, // ID
      fab.modal.theme.id !== undefined ? `theme-${fab.modal.theme.id}` : `theme-blank`, // Theme
      fab.size.type, // BoxSize
    ];

    // Load Dialog.
    let option = {
      title: jQuery(targetContent).data('title'),
      icon: jQuery(targetContent).data('icon'),
      content: jQuery(targetContent).children(':first'),
      draggable: fab?.modal?.navigation?.draggable ? true : false,
      escapeKey: fab?.modal?.navigation?.escapeKey ? true : false,
      backgroundDismiss: fab?.modal?.navigation?.backgroundDismiss ? true : false,
      closeIconClass: `fas fa-times text-base`,
      theme: theme.join(','),
      animation: 'fabcustomcloseanimation',
      closeAnimation: 'fabcustomcloseanimation',
      animationSpeed: '1000',
      onOpenBefore: function () {
        // Animation.
        let container = jQuery('.jconfirm-box-container');
        container.hide();
        setTimeout(function () {
          container.show();
          container.addClass('jconfirm-animation-fabmodalopen');
        }, 1);

        // Styling - FAB Container.
        let fabStyling = `fab-container `;
        fabStyling += this.draggable ? 'fab-modal-draggable ' : 'fab-modal-notdraggable'; // Check Dragabble
        jQuery('.jconfirm').addClass(fabStyling);
      },
      onOpen: function () {
        // Extra Navigation Button.
        jQuery('.jconfirm-closeIcon').before(`<div class="jconfirm-navigation"></div>`);

        // Navigation Maximize.
        if (fab?.modal?.navigation?.buttons?.maximize) {
          FABModal.navigation_maximize(fab);
        }

        // Navigation Hotkey.
        if (fab?.hotkey) {
          FABModal.navigation_hotkey(fab.hotkey);
        }

        // Enable Draggable for Icon Container.
        if (this.draggable) {
          let $i = this.$el.find('.fab-modal-icon-container');
          let that = this;
          $i.on('mousedown', function (e) {
            $i.addClass('jconfirm-hand');
            that.mouseX = e.clientX;
            that.mouseY = e.clientY;
            that.isDrag = true;
          });
        }
      },
      onClose: function () {
        // Animation.
        let container = jQuery('.jconfirm-box-container');
        container.addClass('jconfirm-animation-fabmodalclose');

        // Unbind Draggable for Icon Container.
        if (this.draggable) {
          let $i = this.$el.find('.fab-modal-icon-container');
          $i.unbind('mousedown');
        }
      },
    };

    // Store the dialog to window.
    let dialogs = window.FAB_PLUGIN.dialogs || {};
    dialogs[`fab-modal-${fab.ID}`] = jQuery.dialog(option);
    window.FAB_PLUGIN.dialogs = dialogs;
  }

  /**
   * Close Modal Link
   *
   * @return void
   * */
  static event_close_link() {
    jQuery('.fabclosemodal').on('click', function () {
      FABModal.close_dialog();
    });
  }

  /**
   * Register On Click Event
   * - This is required for third party plugins to trigger the modal.
   *
   * @return void
   * */
  static register_on_click_event() {
    jQuery('.fab-link-modal').on('click', function () {
      let id = jQuery(this).data('id');
      let fab = window.FAB_PLUGIN.to_display.find((e) => e.ID === id);
      FABModal.handle_click({ detail: { fab_item: fab } });
    });
  }

  /**
   * Enable only single dialog to be active
   *
   * @return void
   * */
  static close_dialog() {
    let dialogs = window.FAB_PLUGIN?.dialogs || {};
    if (Object.keys(dialogs).length > 0) {
      for (let i in dialogs) {
        dialogs[i].close();
      }
    }
  }

  /**
   * Navigation Maximize Button
   *
   * @param {Object} fab - The FAB object.
   * @return void
   * */
  static navigation_maximize(fab) {
    jQuery('.jconfirm-navigation').append(
      `<div class="jconfirm-maximize cursor-pointer"><i class="fas fa-expand"></i></div>`
    );
    jQuery('.jconfirm-maximize').on('click', function () {
      let confirmBox = jQuery('.jconfirm-box');
      if (confirmBox.data('maximize') == 'true') {
        // Transform to normal size.
        jQuery('.jconfirm').removeClass('jconfirm-maximized');
        jQuery('.jconfirm-box-container').css('transform', 'translate(0)');
        jQuery('.jconfirm-box').data('maximize', 'false');
        jQuery('i', this).addClass('fa-expand');
        jQuery('i', this).removeClass('fa-compress');
      } else {
        // Transform full width and height.
        jQuery('.jconfirm').addClass('jconfirm-maximized');
        jQuery('.jconfirm-box-container').css('transform', 'translate(0,0)');
        jQuery('.jconfirm-box').data('maximize', 'true');
        jQuery('i', this).removeClass('fa-expand');
        jQuery('i', this).addClass('fa-compress');
      }
    });
  }

  /**
   * Navigation Hotkey
   *
   * @param {String} hotkey - The hotkey.
   * @return void
   * */
  static navigation_hotkey(hotkey) {
    hotkey = hotkey.replace('ctrl', '⌃');
    hotkey = hotkey.replace('alt', '⌥');
    hotkey = hotkey.replace('shift', '⇧');
    hotkey = hotkey.replace('+', ' ');
    hotkey = `<div class="jconfirm-hotkey">${hotkey.toUpperCase()}</div>`;
    jQuery('.jconfirm-navigation').prepend(hotkey);
  }
}
